
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/panduan-konsumen",
      function () {
        return require("private-next-pages/panduan-konsumen/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/panduan-konsumen"])
      });
    }
  